<!--报警管理-->
<template>
    <div class="contentArea" style="position: relative;background:#FFF">

      <cardTable title="报警管理">
          
          <div slot="search" ref="search">
          <Form ref="formInline" :model="form_filter" class="tableHeaderForm" @keydown.enter.native="search" inline>
            <Row>
              <Col>
                <!-- <FormItem >
                  <Input type="text" style="width:150px" v-model="form_filter.house_name" placeholder="所属商户"/>
                </FormItem> -->
                <!-- <FormItem  prop="merchant_code">
            <Select v-model="form_filter.merchant_code"  filterable placeholder="请选择商户">
              <Option v-for="(item,i) in merchant_list" :key="i" :value="item.merchant_code">{{item.shop_name}}</Option>
            </Select> 
        </FormItem> -->
        <FormItem label="代理商">
                  <Cascader :data="merchantData" change-on-select v-model="form_filter.merchant_code" transfer placeholder="请选择代理商" filterable></Cascader>
               </FormItem> 
              </Col>
              <!-- <Col>
                <FormItem >
                  <Input type="text" style="width:150px" v-model="form_filter.alarm_level" placeholder="请输入报警级别"/>
                </FormItem>
              </Col> -->
              <Col>
                <!-- <FormItem >
                  <Input type="text" style="width:150px" v-model="form_filter.shop_name" placeholder="状态"/>
                </FormItem> -->
                <FormItem  prop="status">
            <Select v-model="form_filter.status"  filterable placeholder="请选择状态">
              <Option v-for="(item,i) in statuslist" :key="i" :value="item.value">{{item.name}}</Option>
            </Select> 
        </FormItem>

              </Col>
              
              <Col>
                <FormItem >
                  <Button v-for="(item,index) in topButtonList" :type="item.type"
                          style="margin-right: 5px;" @click="item.method" :key="index">{{item.name}}</Button>
                </FormItem>
              </Col>
            </Row>
          </Form>
          <div slot="btnExtra" class="handle_operation">
            <Tooltip v-for="(item,index) in headBtnList1" :key="index"  :content="item.name" placement="bottom">
              <Button  
                  :type="item.type"      
                  style="margin-right: 5px;" 
                  @click="item.method" 
                  :key="index" 
                  :icon="item.icon"></Button>
            </Tooltip>
          </div>
        </div>
          <packageTable
              ref="contentBaseRef"
              class="contentBaseRef noHeaderTable"
              :height="tableHeight"
              :tableData="tableData"
              rowKey='id'
              :columnsData="columnsData"
              :loading="tableLoading"
              :tabletotallen="tabletotallen"
              :reduceheight="reduceheight"
              :border="border"
              :stripe="stripe"
              :showSearchBtn="false"
              :showTableHeader="false"
              :tablePageSize="reqBase.page_size"
              @pageonChange="pageonChange"
              @pageSizeChange="pageSizeChange"
              @showSearchParel="showSearchParel"
              @refreshBtn="init"
              @getSelect="idSelectChange" 
              >
              
            </packageTable>
        </cardTable>
      <addCom :showModal="showAddModal" className="vertical-center-modal" :ids="ids" :parent_name="parent_name" :editData="editData" :editModal="editModal" :title="modalTitle" :parent_code="parent_code"></addCom>
      <handleCom :showModal="showHandleModal" className="vertical-center-modal" :parent_name="parent_name" :editData="editData" :editModal="editModal" :title="modalTitle" :parent_code="parent_code"></handleCom>
    
    </div>
  </template>
   
  <script>
    import packageTableMixins from "@/mixins/packageTableMixins.js";
    import {alarm_list,merchant_del,get_merchant_all} from '@/api/jingxiaoshang'
    import addCom from './components/addCom'
    import handleCom from './components/handleCom'
   // import viewVideo from './components/viewVideo'
    export default {
      name: "project",
      mixins: [packageTableMixins],
      data() {
        return {
          merchantData:[],
          showVideoModal:false,
          //模拟数据列表
          switchList:{

          },
          merchant_list: [],
          statuslist: [
              { "name": "未处理", "value": 1 },
              { "name": "已处理", "value": 2 }, 
          ],
          //共用的查询与重置
      topButtonList:[
        {
          name:'查询',
          type:'primary',
          method:this.search
        },
        {
          name:'重置',
          type:'error',
          method:this.reset
        }
            ],  
          ids:[],
          parent_name:null,
          editData:null,
          editModal:false,
          modalTitle:'新增',
          parent_code:null,
          reduceheight:78,
          showAddModal: false,
          showHandleModal:false,
          headBtnList:[
            {
              name:'查询',
              type:'primary',
              method:this.search
            },
            {
              name:'重置',
              type:'error',
              method:this.reset
            },
  
          ],
          headBtnList1:[
            {
              name:'批量处理',
              type:'primary',
              icon:'md-hand',
              method:this.addModuleShow
            },
            {
              name:'刷新',
              icon:'ios-refresh',
              type:'primary',
              method:this.init
            }
          ],
          moduleData:[],//模块
          stateData:[
            {
              value:-1,
              label:'全部'
            },
            {
              value:0,
              label:'禁用'
            },
            {
              value:1,
              label:'启用'
            }
          ],
          form_filter:{
            merchant_code:null,
            status: null,
            alarm_level:null
          },
          searchReq:{
            mods:[],
          },
          tableData:[
          ],
            columnsData: [
            {
              title: '多选',
            //  key: 'id',
              align: 'center',
              width: 100,
              type: 'selection'
            },
            {
              title: '设备ID(查看详情)',
              key: 'device_id',
              align: 'center',
            },
            {
              title: '所属代理商',
              key: 'shop_name',
              align: 'center',
            },
           
            {
              title: '告警原因',
              key: 'alarm_type_name',
              align: 'center',
            },
            {
              title: '告警时间',
              key: 'alarm_time',
              align: 'center',
             
            },
            {
              title: '状态',
              key: 'status',
              align: 'center',
              render: (h, { row }) => {
                let result = ""
                let color=''
                if (row.status === 1) {
                  color="error"
                  result='未处理'
                } else if (row.status === 2) {
                  color="primary"
                  result='已处理'
                }  
                return h('Tag',{
                    props:{
                      color
                    }
                  },result)
              }
            },
            
            {
              title: '处理人',
              key: 'handle_user_name',
              align: 'center',
            },
            {
              title: '处理时间',
              key: 'handle_user_time',
              align: 'center',
            },
            {
              title: '操作',
              key: 'explain',
              align: 'center',
            //  fixed: 'right',
              width:180,
                render: (h, { row }) => {
                    let arr = [
                    ];

                    if (row.status === 1) {
                    arr.push(h("Button",{
                    style:{
                      marginRight:"3px",
                      marginBottom:"3px",
                      color:'#2d8cf0',
                    },
                    props:{
                      size:"small",
                      type:'text',
                    },
                    on:{
                      "click":()=>{
                        this.handleModuleShow(row);
                      }
                    }
                  },"处理"))
                      } 
                  
                let but = h("div",arr);
                    
                return but;
              }
            }
          ],
          tableLoading:false,
          tabletotallen:0,
          border:true,
          stripe:true,
          moduleShow:false,
          addBase:{
            name:"",
            code:"",
            state:"",
            explain:""
          },
          reqBase:{
            page:1,
            type:1
          },
          states:[
            {
              value:0,
              label:"禁用"
            },
            {
              value:1,
              label:"启用"
            }
          ],
          
        }
      },
      components: {
        addCom,
        handleCom
      },
      computed: {
      },
    methods: {
      getMerchantData() {
      console.log(111)
      this.merchantData.splice(0)
      get_merchant_all().then(res=>{
        if (res.result === 0) {
          console.log(data)
          let data = res.body
          this.checkTree(data)
         // console.log('a',data)
          this.merchantData=data
        }
      })
  },
  checkTree(arr){
      for(let i in arr){
        
        if(arr[i].shop_name){
          arr[i].value=arr[i].merchant_code
          arr[i].label=arr[i].shop_name
          arr[i].title=arr[i].shop_name
        }else if(arr[i].shop_name){
          arr[i].title=arr[i].shop_name
        }
        if(arr[i].children_shop && arr[i].children_shop.length>0){
          arr[i].children.push(...arr[i].children_shop)
        } 
        if(arr[i].children && arr[i].children.length>0){
          this.checkTree(arr[i].children)
        }
      }
      },  
    
      changeSwitch(val,id,index){
        console.log(val)
        if(this.switchList.hasOwnProperty(id)){
          this.$set(this.switchList[id],index,val)
        }else{
          this.$set(this.switchList,id,{})
          this.$set(this.switchList[id],index,val)
        }
        localStorage.setItem('switchList',JSON.stringify(this.switchList))
      },
      idSelectChange(SelectItem) {    
        this.ids.splice(0)
        if (SelectItem && SelectItem.length > 0) {
          for (let i in SelectItem) {
          let list=SelectItem[i];
          this.ids.push(list.id);
            // this.ids = list.id
          }
          }
          console.log(this.ids)
      },
        reset(){
          this.form_filter={
            merchant_code:null,
            house_name:null
          };
          this.search();
        },
        search(){
          this.onSearch(this.form_filter);
        },
      init() {
         // debugger
          this.getMerchantData();
          this.getPageSizeToStorage();
          this.getData();
        },
        /**
         * 初始化数据
         */
        getData(){
          this.tableLoading=true;
          const vm = this;
          //;
          let callbak = res => {
            this.tableLoading=false;
  
              if(res.result === 0){
                vm.tableData=res.body.list||[];
                vm.tabletotallen = res.body.total;
              }else {
                vm.tableData = [];
                this.$Message.error(res.errorMsg);
              }
            };
          let state=this.reqBase.state;
          if(this.reqBase.state===-1){
            state="";
          }
          let mod_code=this.reqBase.mod_code;
          if(this.reqBase.mod_code==-1){
            mod_code="";
          }
          console.log(111) 
          alarm_list({...this.reqBase,state,mod_code}).then(res => {
            callbak(res); 
          }).catch(err=>{
            this.tableLoading=false;
          })

//商户列表
merchant_list({
              page: 1,
              page_size: 100000000,
              type: localStorage.getItem('account_type')
            }).then(res => {
              if(res.result===0){
                this.merchant_list = res.body.list || [];
                 console.log(res.body.list)
                //this.$parent.init() 
                //this.handleReset(this.formName)
                //this.onCancel() 
              }else{
                this.$Message.error(res.errorMsg)
                this.backStatus()
              }
            }).catch(()=>{
              this.backStatus()
            })


        },
        /**
         * 重置搜索框
         */
        resetSearch(){
          this.searchReq={
            mods:[]
          }
        },
        okSearch(){
          Object.assign(this.reqBase,this.searchReq);
          //重置当前页为1
          this.reqBase.page=1;
          this.$refs.contentBaseRef.initcurrentPage();
          this.init();
        },
        /**
         * 翻页
         */
        pageonChange(index){
          this.reqBase.page = index;
          this.getData();
        },
        /**
         * 筛选
         */
        showSearchParel(){
            this.$refs.search.expandPanel();
        },
        /**
         * 控制模态框显示隐藏
         * type 显示隐藏
         * handle true新增 false编辑
         * row 本条数据
         */
        addModuleShow(){
          this.modalTitle='批量处理'
          this.parent_code=''
          this.parent_name='无'
          this.editModal = false
          this.ids = this.ids
          this.showAddModal=!this.showAddModal
        },
        handleModuleShow(row){
          this.modalTitle='告警处理'
          this.parent_code=''
          this.parent_name='无' 
          this.editModal = true
          this.editData=row
          this.showHandleModal=!this.showHandleModal
        },
        addChild(row){
          this.modalTitle='处理'
          this.editModal=false
          this.parent_code=row.area_code
          this.parent_name=row.area_name
          this.showAddModal=!this.showAddModal
        },
        edit(row){
          this.editData=row
          this.showVideoModal=!this.showVideoModal
        },
        
        
        /**
         * 删除
         */
        delModule(row){
          const _this = this;
          let config = {
            loading:true,
            title:"删除",
            width:400,
            content:`<p>确认删除<span style="color: #f60;">${row.area_name}</span>？</p>`,
            onOk:()=>{
              let params = {
                merchant_code:row.merchant_code
              },callbak = req => {
                if(req.result === 0){
                  this.$Message.success(this.$t('删除成功！'));
                  this.$Modal.remove();
                  this.init();
                }else {
                  this.buttonLoading=false;
                  this.$Message.error(req.errorMsg);
                }
              };
              //删除接口
              merchant_del(params).then(res=>{
                callbak(res)
              });
            }
          };
          this.$Modal.confirm(config)
        },
      },
      mounted() {
        window.onresize =()=>{
          this.changeTableHeight()
        }
        this.$nextTick(()=>{
          let innerWidth=window.innerHeight-66
          this.treeHeight=innerWidth
          this.changeTableHeight()
          //显示标记的数据
          let switchList=localStorage.getItem('switchList')
          if(switchList){
            this.$set(this,'switchList',JSON.parse(switchList))
          }
        })
        this.init();
      },
      created() {
      },
      destroyed(){
         window.onresize =null
      }
    }
  </script>
  
  <style scoped>
    .w6{
      width: calc(25% - 10px);
      margin-left: 5px;
      margin-right: 5px;
    }
    .ivu-picker-confirm-time{background:#fff}
    .handle_operation{
      float: right;
    margin-right: 50px;
    margin-top: -39px;
    }
  </style>
  